"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("./each");
var is_object_1 = require("./is-object");
/**
 * 返回 object 上所有键名的数组。即 Object.keys
 *
 * @param {object} object 需要获取键名的对象
 * @returns {string[]} 所有键名
 */
function allKeys(object) {
    if (!is_object_1.default(object))
        return [];
    var keys = [];
    each_1.default(object, function (v, k) {
        keys.push(k);
    });
    return keys;
}
exports.default = allKeys;
//# sourceMappingURL=all-keys.js.map